export default [
    {
        key: 1,
        img: "MasterCard",
        url: "web:https://www.mastercard.ba/"
    },
    {
        key: 2,
        img: "MaestroCard",
        url: "web:https://www.mastercard.ba/bs-ba/consumers/find-card-products.html"
    },
    {
        key: 3,
        img: "IDCheck",
        url: "web:https://www.mastercard.ba/bs-ba/issuers/identity-check.html"
    },
    {
        key: 4,
        img: "Visa",
        url: "web:https://www.visaeurope.com"
    },
    {
        key: 5,
        img: "VisaSecure",
        url: "web:https://www.visaeurope.com/making-payments/verified-by-visa/"
    },
    {
        key: 6,
        img: "Sberbank",
        url: "web:https://www.sberbankbl.ba/"
    }
];
